var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.768 15L12.538 4.43 2.153 14.765 0 12.516 12.616 0 25 12.825 22.768 15z",
    fill: "#F5F5F5"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDI1IDE1IiBmaWxsPSJub25lIj4KICAgIDxwYXRoIGQ9Ik0yMi43Njc5IDE1TDEyLjUzNzUgNC40MjkyOUwyLjE1MzYxIDE0Ljc2NTZMMi4zMTk0MWUtMDggMTIuNTE1M0wxMi42MTYxIDBMMjUgMTIuODI0N0wyMi43Njc5IDE1WiIgZmlsbD0iI0Y1RjVGNSIvPgo8L3N2Zz4K";
export { SvgArrowWhite as ReactComponent };